<template>
  <div :class="isLoggedIn ? 'wrapper d-flex align-items-stretch route-'+$router.currentRoute.name : ''">
    <Header />
    <div id="content" :class="isLoggedIn ? 'side-nav-active' : ''">
      <router-view></router-view>
    </div>
    <div id="global-spinner" v-show="dataLoading && onlyOneSpinner()">
      <b-spinner label="Loading"></b-spinner>
    </div>

        <b-modal centered hide-footer v-model="showSocialMediaExportModal" id="socialMediaExportModal" title="Creating Social Media Export">

          <div style="text-align:center">
          	<b-spinner v-if="isLoadingExport" label="Loading"></b-spinner>
          	<div v-if="!isLoadingExport">
          	<a class="btn btn-primary" v-if="downloadLink" :href="downloadLink" @click="showSocialMediaExportModal = false;">Download</a>
          	</div>
          </div>
        </b-modal>
        <b-modal centered hide-footer hide-backdrop  no-close-on-backdrop  content-class="shadow" v-model="showSocialMediaImportModal" id="socialMediaImportModal" title="Import Social Media Posts">
        	<p><a href="/assets/import-social-media.xlsx"  target="_blank">Download example .xlsx file</a></p>
        	<VueFilePond
        	    name="file"
        	    ref="importPond"
        	    label-idle="Upload .xlsx"
        	    :allow-multiple="true"
        	    :dropOnElement="true"
        	    :dropOnPage="false"
        	    :allowRevert="false"
        	    v-bind:files="filepond"
        	    v-on:init="handleFilePondInit"
        	    credits="false"
        	  />
    	   	  <div class="imported-results" v-show="loadedImportResults">
    	   	  	<b-button v-b-toggle.collapse-import-results variant="text">
    	   	  		<i v-show="!expandImportResults" class="fas fa-chevron-down collapse-indicator"></i>
    	   	  		<i v-show="expandImportResults" class="fas fa-chevron-right collapse-indicator"></i>
    	   	  	  <strong style="color:var(--error--color--border)" v-if="importedResults.errors.length > 0">ERROR: {{importedResults.errors.length}} row(s) have problems.</strong>
    	   	  	  <strong>{{importedResults.imported.length}} posts imported.</strong>
    	   	  	  <strong>{{importedResults.total}} data rows in file.</strong>
    	   	  	  <strong>Click to view details.</strong>
    	   	  	  <br/>
    	   	  	</b-button>
    	   	  	<b-collapse id="collapse-import-results" v-model="expandImportResults">
    	   	  	  <div class="collapse-inner">

    	   	  	  	<ol v-if="importedResults.errors.length > 0" >
    	   	  	  		<li :class="`{e.new ? 'imported-new':'imported-existing'}`" v-for="(e, indexe) in importedResults.errors" >
    	   	  	  			<span class='imported-title'>{{e.title}}</span>
    	   	  	  			<span class='imported-publish_date' v-if="e.publish_date != null">{{e.publish_date | moment("MMM D,YYYY HH:mm a")}}</span>
    	   	  	  			<span class='imported-publish_date' v-if="e.publish_date == null">No Date Set</span>
    	   	  	  			<span class='imported-social_campaign' v-if="e.social_campaign">Campaign: {{e.social_campaign.title}}</span>
    	   	  	  			<span class='imported-social_series' v-if="e.social_series">Series: {{e.social_series.title}}</span>

    	   	  	  			<span :class="getImportStatusClass(e.status)">Row {{e.row}}; {{e.status.name}}</span>
    	   	  	  		</li>
    	   	  	  	</ol>

    					<ol v-if="importedResults.imported.length > 0" >
    						<li :class="`{s.new ? 'imported-new':'imported-existing'}`" v-for="(s, index) in importedResults.imported" >
    							<span class='imported-title'> <a @click="showEditDeliverableModal(s)">{{s.title}}</a></span>
    							<span class='imported-publish_date' v-if="s.publish_date != null">{{s.publish_date | moment("MMM D,YYYY HH:mm a")}}</span>
    							<span class='imported-publish_date' v-if="s.publish_date == null">No Date Set</span>

    							<span class='imported-social_campaign' v-if="s.social_campaign">Campaign: {{s.social_campaign.title}}</span>
    							<span class='imported-social_series' v-if="s.social_series">Series: {{s.social_series.title}}</span>

    							<span :class="getImportStatusClass(s.status)">Row {{s.row}}; {{s.status.name}}</span>
    						</li>
    					</ol>
    	   	  	  </div>
    	   	  	</b-collapse>
    				</div>

        </b-modal>
  </div>
</template>
<script>
import Header from "@/csmworkflow/js/components/common/Header";
import { mapActions, mapGetters, mapState } from 'vuex';
import vueFilePond from "vue-filepond";
const VueFilePond = vueFilePond();
import "filepond/dist/filepond.min.css";


export default {
	data() {
	  return {
		namespace: "",
	  	expandImportResults:false,
	  	importedResults:{
	  		imported:[],
	  		errors:[],
	  		total:0
	  	},
	  	loadedImportResults:false,
	    filepond: [],
	  	showSocialMediaExportModal: false,
	  	showSocialMediaImportModal: false,
	  	isLoadingImport:false,
	  	isLoadingExport:false,
	  	importFilterQuery:null,
	  	downloadError:null,
	  	downloadLink:null,
	  	importError:null,
	  }
	},
  computed: {
    ...mapGetters([
      'dataLoading',
      'preferenceData',
      "systemSettings",
    ]),
    ...mapActions([
      'startDownloadDeliverableExcel'
    ]),
	  ...mapState({
		  deliverableDetail(state, getters) {
			  return getters[this.namespace + 'deliverableDetail']
		  },
	  }),
    isLoggedIn() {
        if (this.$router.currentRoute.name == 'dashboardMediaCalls'){
            return true;
        }else{
            return this.$store.getters.isLoggedIn;
        }
    }
  },
  components: {
    Header,
    VueFilePond,
  },
  methods: {
    ...mapActions([
		'fetchSystemSettings', 
		'fetchAllCompanies', 
		'fetchUserPermissions', 
		'fetchAlerts', 
		'fetchUserAlerts', 
		'fetchNotification', 
		'fetchUserProjectsCount', 
		'fetchAllProjects', 
		'getPreference',
		"fetchWidgetSettings"
	]),

    onlyOneSpinner() {
    	if ($("#global-spinner-above-list").length > 0) {
    			return false;
    	}
    	if ($("#global-spinner-inline").length > 0) {
    			return false;
    	}
    	return true;
    },

		onPostModalClose() {
      $('#content').removeClass('disable-pointer-events');
      $('#editOrganicSocialMediaPlanModal .modal-content').removeClass('disable-pointer-events');

    		// make sure there isn't any calendar tooltips open.
				setTimeout(function() {
  				$(".dhx_year_tooltip").hide();
  			}, 0);
		},


		    getImportStatusClass(status) {
		    	let css = "imported-status ";
		    	return css + "imported-status-"+status.slug;
		  	},

		      // Resource upload file
		    handleFilePondInit() {
		      this.$refs.importPond._pond.setOptions({
		        server: {
								headers: {
									Authorization: "Bearer " + this.$store.getters.authToken
								},
								process: {
									method: 'POST',
									url: `${this.apiUrl}importSocialMedia`,
									withCredentials: true,
		              ondata: this.handleFilePondSubmit,
		              onload: this.handleFilePondSuccess,
		          },
		        }
		      });
		    },
		    handleFilePondSubmit(data) {
		    	this.isLoadingImport = true;
		    	this.loadedImportResults = false;
		    	this.importedResults = {
		    		imported:[],
		    		errors:[]
		    	};
		    	data.filterQuery = this.importFilterQuery;

		      return data;
		    },
		    handleFilePondSuccess(response, file) {
		    	this.importedResults = JSON.parse(response);
		    	for (var x = 0; x < 10; x++) {
		    		for (var y = 0; y < this.importedResults.length; y++) {
		    			this.importedResults.imported.push(this.importedResults.imported[$y]);
		    		}
		    		if (this.importedResults.imported.length > 20) {
		    			break;
		    		}
		    	}
		    	this.isLoadingImport = false;
		    	this.loadedImportResults = true;
		    	if (file) {
			    	this.$nextTick(() => {
			    	    this.$refs.importPond.removeFile(file.id);
			    	});
			    }

		    },


  },
  created(){
  },
  mounted() {
  	this.$root.$on("postModalClose", this.onPostModalClose);

	  this.$root.$on("showEditOSMPModal", (deliverableId) => {
		  this.$store.state.deliverables.editDeliverableModal = false;
		  this.$bvModal.hide('editSocialModal');
		  this.$bvModal.hide('editRelatedSocialModal');
		  // compare if parent_deliverable_id in breadcrumb and namespaced deliverableDetail.id same
		  if(this.deliverableDetail.id != deliverableId) {
			  let that = this;
			  this.$store.dispatch(this.namespace + 'getDeliverableDetail', { deliverableId: deliverableId }).then(function () {
				  that.$bvModal.show('editOrganicSocialMediaPlanModal');
			  });
		  } else {
			// if same, plan modal already open
			// then no api call to refetch same DeliverableDetail
			// close social media post modal, show the opened plan modal in focus 
			this.$bvModal.show('editOrganicSocialMediaPlanModal');
		  }
	  });

		this.$root.$on('exportSocialMediaExcel', (customFilter) => {
			let that = this;
				if (customFilter) {
					this.showSocialMediaExportModal = true;
					this.isLoadingExport = true;
					this.downloadError = "";

					this.startDownloadDeliverableExcel(customFilter).then(function(response) {
						if (response.data.token != "") {
								that.downloadLink = process.env.MIX_API_BASE_URL + "downloadFile/" + response.data.token;
						} else {
								that.downloadLink = "";
								that.downloadError = "Invalid download token returned from server.";
						}
						that.isLoadingExport = false;
					});
				}
		});


		this.$root.$on('importSocialMediaExcel', (customFilter) => {
				let that = this;
				if (customFilter) {
					this.showSocialMediaImportModal = true;
					this.isLoadingImport = true;
					this.uploadError = "";
					this.importFilterQuery = customFilter;
				}
		});


    if (this.$router.currentRoute.name != 'dashboardMediaCalls'){
      if(this.isLoggedIn) {
        if(!this.preferenceData) {
            this.getPreference()
        }
        if (!this.systemSettings) {
          this.fetchSystemSettings()
        }
        this.fetchAllCompanies();
        this.fetchUserPermissions();
        this.fetchUserProjectsCount();
        this.fetchAllProjects();
        this.fetchWidgetSettings();

        // let that = this;
        // let loadingNotifications = setInterval(function() {
        //   that.fetchAlerts();
        // }, 5000)
      }
    }
  },
};
</script>
